import type { RouteObject } from 'react-router-dom';
import { PermissionRoute } from '@/features/auth';
import { RoleList } from '../pages/RoleList';
import { RoleDetail } from '../pages/RoleDetail';

export const rolesRoutes: RouteObject[] = [
  {
    path: 'admin/roles',
    children: [
      {
        element: <PermissionRoute requiredPermissions={[{ resource: 'role', action: 'browse' }]} />,
        children: [{ index: true, element: <RoleList /> }],
      },
      {
        element: <PermissionRoute requiredPermissions={[{ resource: 'role', action: 'read' }]} />,
        children: [{ path: ':id', element: <RoleDetail /> }],
      },
    ],
  },
];
